import { Box, Typography } from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import React from 'react';
import { IoMdAdd } from 'react-icons/io';

import { PrimaryButton } from '../atoms';

import { PatientProfileTableProps } from './types';

export const PatientProfileTable = ({
  data,
  children,
  columns,
  onAddClick,
  title,
}: PatientProfileTableProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', paddingBottom: '20px' }}>
      <Box sx={{ paddingBottom: '20px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: '10px',
          }}
        >
          <Typography variant="h4" sx={{ textAlign: 'left' }}>
            {title}
          </Typography>
          <Box sx={{ display: 'flex', gap: 5, marginLeft: 'auto' }}>
            <PrimaryButton
              aria-label={`Add ${title}`}
              data-testid={`add-${title.toLowerCase().replace(/\s+/g, '-')}`}
              onClick={onAddClick}
            >
              <IoMdAdd style={{ fontSize: '1.5rem' }} />
            </PrimaryButton>
          </Box>
        </Box>
        {children}
        <MaterialReactTable
          // @ts-ignore
          columns={columns}
          // @ts-ignore
          data={data}
          enableSorting={false}
          enableColumnActions={false}
          enableTopToolbar={false}
          enablePagination={true}
        />
      </Box>
    </Box>
  );
};
